import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "发评论", -1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "btns-holder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["comment-create-container", { 'is-show': _ctx.isShow }])
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args))),
      class: "header"
    }, [
      _hoisted_1,
      _createVNode(_component_el_divider, { direction: "vertical" }),
      _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          (_ctx.isShow)
            ? (_openBlock(), _createBlock(_component_ArrowUp, { key: 0 }))
            : (_openBlock(), _createBlock(_component_ArrowDown, { key: 1 }))
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.formEdit.content,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formEdit.content) = $event)),
            type: "textarea",
            placeholder: "支持MD语法..."
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", {
            class: _normalizeClass(["limit", { 'is-danger': _ctx.formEdit.content.length > 100 }])
          }, _toDisplayString(_ctx.formEdit.content.length) + " / 100", 3),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.formEdit.is_anon,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formEdit.is_anon) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("是否匿名")
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.doSendComment
            }, {
              default: _withCtx(() => [
                _createTextVNode("发送")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 512), [
          [_vShow, _ctx.isShow]
        ])
      ]),
      _: 1
    })
  ], 2))
}